<template>
  <section class="cars-nav" :class="[{ fixed: fixed && can_fixed }, nav_class]">
    <!-- <div class="arrow arrow-left nav"></div>
    <div class="arrow arrow-right nav"></div>
    <div class="swiper-container nav-swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in nav_list"
          :key="index"
        >
          <div
            class="cars-nav__item"
            :class="{ active: item.active }"
            @click="changeFilter(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div> -->

    <div class="cars-nav__list">
      <div
        v-for="(item, index) in nav_list"
       :key="index"
        class="cars-nav__item"
        :class="{ active: item.active }"
        @click="changeFilter(item)"
      >
        {{ item.name }}
      </div>
    </div>

  </section>
</template>

<script>
import Mixin from "../common/mixin";
import Swiper from "swiper";
import $ from "jquery";
import smoothScrollTo from "../common/smoothScrollTo";

export default {
  name: "cars-nav",
  props: ["nav_list", "nav_class", "can_fixed"],
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      fixed: false,
    };
  },
  mounted() {
    console.log(this.nav_list);
    window.addEventListener("scroll", () => {
      const blockCarsElem = document.querySelector(".block-cars");
      if (
        window.pageYOffset >= blockCarsElem.offsetTop &&
        window.pageYOffset <
          blockCarsElem.offsetHeight + blockCarsElem.offsetTop - 200
      ) {
        this.fixed = true;
        this.$emit("change-position", this.fixed);
      } else {
        this.fixed = false;
        this.$emit("change-position", this.fixed);
      }
    });

    setTimeout(() => {
      this.initSwiper();
    }, 0);
  },
  watch: {
    device_platform() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
        this.$nextTick(this.initSwiper);
      }
    },
  },
  methods: {
    scrollTo(where) {
      let offset = this.device_platform === "desktop" ? 110 : 160;
      smoothScrollTo($("#" + where).offset().top - offset);
    },
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.${this.nav_class} .nav-swiper`, {
        slidesPerView: "auto",
        loop: false,
        simulateTouch: true,
        navigation: {
          nextEl: `.${this.nav_class} .arrow-right.nav`,
          prevEl: `.${this.nav_class} .arrow-left.nav`,
        },
      });
    },
    changeFilter(value) {
      this.$emit("change", value);

      if (this.can_fixed) {
        this.$nextTick(() => {
          this.scrollTo("cars");
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.cars-nav {
  position: relative;
  background: #fff;

  &.fixed {
    // position: fixed;
    // top: 64px;
    // bottom: auto;
    // z-index: 10;
    // width: 100%;
    // max-width: 1400px;
    // background-color: #fff;

    // .cars-nav__item {
    //   padding: 23px 0;
    // }
  }

  &.nav-stock {
    .cars-nav__item {
      border: none;

      &.active {
        color: #000;
      }
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    height: 70px;
    color: $gray_dark;
    font-size: 14px;
    font-weight: bold;
    font-family: "AudiTypeExt", sans-serif;
    position: relative;
    text-align: center;
    border-bottom: 2px solid #b3b3b3;
    cursor: pointer;
    transition: $transition;
    flex: 1;

    &:hover {
      color: $red;
      border-color: $red;
    }

    &.active {
      color: $red;
      border-color: $red;
    }
  }

  .swiper-slide {
    max-width: 172px;
  }
}

@media (max-width: 800px) {
  .cars-nav {
    .arrow {
      display: none;
    }

    // &.fixed {
    //   position: static;
    //   height: auto;

    //   .cars-nav__item {
    //     padding: 0;
    //   }
    // }

    &__item {
      font-size: 12px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      width: 25%;
      flex: initial;

      &:nth-child(5), &:nth-child(6), &:nth-child(7) {
        width: 33.3%;
      }

      &:nth-child(8), &:nth-child(9) {
        width: 50%;
      }
    }

    .swiper-slide {
      max-width: 105px;
    }
  }
}

@media (max-width: 360px) {
  
}
</style>
